import { Eye } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const EyeIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Eye width={size} height={size} color={color} {...rest} />;

EyeIcon.displayName = 'EyeIcon';

export default EyeIcon;
